export class PasswordInfo {
  currentPassword: string;
  newPassword: string;

  constructor() {

  }
}
